// Site-wide Traditional <-> Simplified Chinese.
// Source text is authored in Traditional ('hant', the default). When the user picks
// Simplified ('hans') we lazy-load OpenCC and convert rendered text in-place, plus
// watch for future renders. We never touch <input>/<textarea> (user-typed data) or
// anything marked [data-noconvert]. Switching locale reloads so each mode starts clean.
const KEY = 'fm_locale';
const HAN = /[㐀-鿿]/;

export function getLocale() {
  try {
    return localStorage.getItem(KEY) === 'hans' ? 'hans' : 'hant';
  } catch (e) {
    return 'hant';
  }
}

export function setLocale(loc) {
  try {
    localStorage.setItem(KEY, loc === 'hans' ? 'hans' : 'hant');
  } catch (e) { /* ignore */ }
  window.location.reload();
}

function skip(parent) {
  if (!parent) return true;
  const tag = parent.tagName;
  if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA' || tag === 'INPUT') return true;
  if (parent.closest && parent.closest('[data-noconvert]')) return true;
  return false;
}

export async function startSimplifiedConversion() {
  let OpenCC;
  try {
    OpenCC = await import('opencc-js');
  } catch (e) {
    return;
  }
  const convert = OpenCC.Converter({ from: 'hk', to: 'cn' });

  const doText = (node) => {
    const v = node.nodeValue;
    if (!v || !HAN.test(v) || skip(node.parentElement)) return;
    const c = convert(v);
    if (c !== v) node.nodeValue = c;   // idempotent: already-simplified -> no change -> no loop
  };
  const doPlaceholder = (el) => {
    if (!el.getAttribute) return;
    const v = el.getAttribute('placeholder');
    if (v && HAN.test(v)) {
      const c = convert(v);
      if (c !== v) el.setAttribute('placeholder', c);
    }
  };
  const walk = (root) => {
    if (root.nodeType === Node.TEXT_NODE) { doText(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    const it = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let n;
    while ((n = it.nextNode())) doText(n);
    if (root.hasAttribute && root.hasAttribute('placeholder')) doPlaceholder(root);
    if (root.querySelectorAll) root.querySelectorAll('[placeholder]').forEach(doPlaceholder);
  };

  walk(document.body);

  const obs = new MutationObserver((records) => {
    for (const r of records) {
      if (r.type === 'characterData') doText(r.target);
      else r.addedNodes.forEach(walk);
    }
  });
  obs.observe(document.body, { childList: true, subtree: true, characterData: true });
}
